import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useLang } from "../store";
import { Clapperboard, Menu, X } from "lucide-react";

function Timecode() {
  const [tc, setTc] = useState("00:00:00:00");
  useEffect(() => {
    const start = Date.now();
    const id = setInterval(() => {
      const d = Date.now() - start;
      const f = Math.floor((d % 1000) / 40);
      const s = Math.floor(d / 1000) % 60;
      const m = Math.floor(d / 60000) % 60;
      const h = Math.floor(d / 3600000);
      setTc(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}:${String(f).padStart(2, "0")}`);
    }, 40);
    return () => clearInterval(id);
  }, []);
  return <span className="font-mono2 text-[11px] tracking-[0.2em] text-amber-500" data-testid="timecode-ticker">TC {tc}</span>;
}

export default function Header() {
  const { lang, setLang, t } = useLang();
  const [mobileOpen, setMobileOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => { setMobileOpen(false); }, [loc.pathname]);

  const links = [
    { to: "/", key: "studio" },
    { to: "/filmografia", key: "filmografia" },
    { to: "/noleggio-attrezzatura", key: "attrezzatura" },
    { to: "/noleggio-costumi", key: "costumi" },
    { to: "/stunt", key: "stunt" },
    { to: "/galleria", key: "galleria" },
    { to: "/produzioni", key: "produzioni" },
    { to: "/chi-sono", key: "chisono" },
    { to: "/contatti", key: "contatti" },
  ];

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-[rgba(7,8,10,0.88)] backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-[1600px] items-center justify-between gap-4 px-4 sm:px-6">
          <Link to="/" className="flex items-center gap-3" data-testid="brand-logo">
            <span className="flex h-9 w-9 items-center justify-center rounded bg-amber-600 text-black">
              <Clapperboard size={20} strokeWidth={2.2} />
            </span>
            <span className="leading-none">
              <span className="font-display block text-lg tracking-wide">{t("brand")}</span>
              <span className="font-mono2 text-[10px] tracking-[0.3em] text-amber-500">{t("badge")}</span>
            </span>
          </Link>

          <nav className="hidden items-center gap-5 lg:flex" data-testid="main-nav">
            {links.map((l) => (
              <NavLink
                key={l.key}
                to={l.to}
                data-testid={`nav-link-${l.key}`}
                className={({ isActive }) =>
                  `text-[13px] font-medium tracking-wide transition-colors ${isActive ? "text-amber-500" : "text-slate-400 hover:text-white"}`
                }
              >
                {t(`nav.${l.key}`)}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <span className="hidden md:inline"><Timecode /></span>
            <button
              onClick={() => setLang(lang === "it" ? "en" : "it")}
              data-testid="language-switcher"
              className="font-mono2 rounded border border-white/15 px-2.5 py-1 text-[11px] tracking-widest text-slate-300 transition-colors hover:border-amber-500 hover:text-amber-500"
            >
              {t("lang")}
            </button>
            <button className="p-2 text-slate-300 lg:hidden" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-toggle">
              {mobileOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>

        {mobileOpen && (
          <nav className="border-t border-white/10 bg-[#0a0b0e] px-6 py-4 lg:hidden" data-testid="mobile-nav">
            <div className="grid grid-cols-2 gap-3">
              {links.map((l) => (
                <NavLink key={l.key} to={l.to} data-testid={`nav-mobile-${l.key}`}
                  className={({ isActive }) => `text-sm ${isActive ? "text-amber-500" : "text-slate-300"}`}>
                  {t(`nav.${l.key}`)}
                </NavLink>
              ))}
            </div>
          </nav>
        )}
      </header>
    </>
  );
}
